/**
 * LuxButton — gold-gradient / ghost / quiet variants.
 *
 * Always renders as a `<button>` unless `as` is provided (e.g. for `<a>` or
 * `<Link>`). The styling lives in landing-luxury.css under `.lux-btn-*` so
 * we can keep this component declarative.
 */
const LuxButton = ({
  variant = "primary",     // "primary" | "ghost" | "quiet"
  size = "md",              // "md" | "lg"
  as: Tag = "button",
  className = "",
  children,
  ...rest
}) => {
  const variantCls = {
    primary: "lux-btn-primary",
    ghost: "lux-btn-ghost",
    quiet: "lux-btn-quiet",
  }[variant] || "lux-btn-primary";
  const sizeCls = size === "lg" ? "lux-btn-lg" : "";
  return (
    <Tag className={`lux-btn ${variantCls} ${sizeCls} ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
};

export default LuxButton;
